import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Achievements.css';
import {
    FaAward, FaCertificate, FaCode, FaDatabase, FaShieldAlt,
    FaClock, FaUsers, FaLinux, FaServer, FaNetworkWired, FaChartLine
} from 'react-icons/fa';
import ieeeImage from '../media/1.jpeg';
import ntiImage from '../media/2.jpeg';

const Achievements = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            easing: 'ease-out-cubic',
        });
    }, []);

    const achievements = [
        {
            id: 1,
            image: ieeeImage,
            icon: <FaCertificate />,
            title: "Backend .NET Developer Trainee",
            organization: "IEEE Kafrelshiekh Student Branch",
            type: "Internship",
            period: "November 2024 - January 2025",
            duration: "3 months",
            location: "Kafr El-Sheikh, Egypt",
            mode: "Hybrid",
            description: "Successfully completed Backend .NET Developer internship at IEEE Kafr El-Sheikh Student Branch through competitive selection process.",
            contributions: [
                {
                    icon: <FaCode />,
                    title: "Task Management Application",
                    description: "Developed a Task Management and Time Tracking web application using ASP.NET Core"
                },
                {
                    icon: <FaShieldAlt />,
                    title: "Authentication System",
                    description: "Implemented user authentication and authorization system"
                },
                {
                    icon: <FaDatabase />,
                    title: "Database Architecture",
                    description: "Built database architecture using Entity Framework Core and SQL Server"
                },
                {
                    icon: <FaClock />,
                    title: "Time Tracking Features",
                    description: "Developed time logging and productivity monitoring functionality"
                }
            ],
            keyAchievements: [
                "Successfully delivered complete task management system within internship period",
                "Implemented secure user management with role-based access control",
                "Built responsive web interface for efficient task organization",
                "Gained practical experience in backend .NET development"
            ]
        },
        {
            id: 2,
            image: ntiImage,
            icon: <FaCertificate />,
            title: "Linux Red Hat Administration Intern",
            organization: "National Telecommunication Institute (NTI)",
            type: "Internship",
            period: "July 2025 - August 2025",
            duration: "2 months (120 hours)",
            location: "Egypt",
            mode: "Remote",
            description: "Successfully completed NTI's Linux Red Hat Administration summer training program with comprehensive technical and professional development.",
            contributions: [
                {
                    icon: <FaLinux />,
                    title: "Linux System Administration",
                    description: "Completed comprehensive Linux system administration and RHCSA certification preparation (90 hours)"
                },
                {
                    icon: <FaServer />,
                    title: "System Security & Management",
                    description: "Mastered user/group management, storage systems, and network configuration"
                },
                {
                    icon: <FaNetworkWired />,
                    title: "Hands-on Practice",
                    description: "Gained extensive experience with virtual machines and remote labs"
                },
                {
                    icon: <FaChartLine />,
                    title: "Professional Development",
                    description: "Enhanced communication, leadership, and project management skills (30 hours)"
                }
            ],
            keyAchievements: [
                "Successfully completed with final score of 77.5%",
                "Gained hands-on experience with command-line operations and file management",
                "Strengthened critical thinking and problem-solving abilities",
                "Learned freelancing, client management, and professional networking"
            ]
        }
    ];

    return (
        <section className="achievements" id="achievements">
            <div className="achievements-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
            </div>

            <div className="container achievements-container">
                <div className="section-header" data-aos="fade-up">
                    <h2 className="section-title">
                        Achievements & <span className="gradient-text">Certifications</span>
                    </h2>
                    <p className="section-subtitle">
                        Professional training and internship accomplishments
                    </p>
                </div>

                <div className="achievements-list">
                    {achievements.map((achievement, index) => (
                        <div
                            className="achievement-card"
                            key={achievement.id}
                            data-aos="fade-up"
                            data-aos-delay={index * 100}
                        >
                            <div className="achievement-image-container">
                                <img src={achievement.image} alt={achievement.title} className="achievement-image" />
                                <div className="image-overlay">
                                    <div className="overlay-icon">{achievement.icon}</div>
                                </div>
                            </div>

                            <div className="achievement-content">
                                <div className="achievement-header">
                                    <h3 className="achievement-title">{achievement.title}</h3>
                                    <p className="achievement-organization">{achievement.organization}</p>
                                    <div className="achievement-meta">
                                        <span className="meta-item">
                                            <FaClock /> {achievement.duration}
                                        </span>
                                        <span className="meta-item">{achievement.period}</span>
                                        <span className="meta-badge">{achievement.mode}</span>
                                    </div>
                                </div>

                                <p className="achievement-description">{achievement.description}</p>

                                <div className="achievement-contributions">
                                    <h4 className="contributions-title">Technical Contributions</h4>
                                    <div className="contributions-grid">
                                        {achievement.contributions.map((contribution, idx) => (
                                            <div className="contribution-item" key={idx}>
                                                <div className="contribution-icon">{contribution.icon}</div>
                                                <div className="contribution-content">
                                                    <h5 className="contribution-title">{contribution.title}</h5>
                                                    <p className="contribution-description">{contribution.description}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="key-achievements">
                                    <h4 className="key-achievements-title">Key Achievements</h4>
                                    <ul className="achievements-list-items">
                                        {achievement.keyAchievements.map((item, idx) => (
                                            <li key={idx} className="achievement-list-item">
                                                <FaAward className="list-icon" />
                                                <span>{item}</span>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Achievements;
